import { useCallback, useMemo } from "react";
import { IOption } from "@evergis/ui";
import { GeometryType } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { GeometryTypeInfo } from "../components/CalculationTemplates/TemplateForm/TemplateForm";

export const useGeometryPropertiesOptions = (geometryTypeInfo: GeometryTypeInfo) => {
  const { t } = useTranslation("dialogs");
  const { geometryAttribute, geometryType } = geometryTypeInfo;

  const commonOptions = useMemo(
    () => [
      { text: t("featuresMultiEdit.coordinates"), value: "coordinate" },
      { text: t("featuresMultiEdit.longitude"), value: "longitude" },
      { text: t("featuresMultiEdit.latitude"), value: "latitude" },
    ],
    [t],
  );

  const lineOptions = useMemo(() => [{ text: t("featuresMultiEdit.length"), value: "length" }], [t]);

  const polygonOptions = useMemo(
    () => [
      { text: t("featuresMultiEdit.perimeter"), value: "perimeter" },
      { text: t("featuresMultiEdit.area"), value: "area" },
    ],
    [t],
  );

  const getGeometryOptions = useCallback(() => {
    switch (geometryType) {
      case GeometryType.Polygon:
        return [...polygonOptions, ...commonOptions];
      case GeometryType.Polyline:
        return [...lineOptions, ...commonOptions];
      default:
        return commonOptions;
    }
  }, [commonOptions, geometryType, lineOptions, polygonOptions]);

  const options = getGeometryOptions();

  return useMemo(
    () =>
      options.map((option: IOption) => ({
        text: option.text,
        value: `${option.value}(${geometryAttribute})`,
      })),
    [geometryAttribute, options],
  );
};
